import React from 'react';
import ChatInterface from '../../components/Chat/ChatInterface';
import Page from '../../components/Page';

const ChatPage: React.FC = () => {
  return (
    <Page type="chat">
      <ChatInterface
        isStudy={false}
        placeholder="Ask me about any medical topic..."
      />
    </Page>
  );
};

export default ChatPage;
